import React from 'react';
import PropTypes from 'prop-types';

import '../styles/BigSelectMenu.css';

import MenuHeader from './MenuHeader';

const BigSelectMenu = ({ name, settings, index }) => (
    <>
     <MenuHeader itemName={name} />
      <div className="Big-select-container">
        <div>
          {`${settings[index]} / ${settings.length}`}
        </div>
        <div className="Big-select">
          <div className="Big-select-options-top">
            {`${settings[index]}:`}
          </div>
          <div className="Big-select-options-bottom">(NONE)</div>
        </div>
        <div className="Big-select-buttons">Cancel</div>
      </div>
  
    </>
  );
  
BigSelectMenu.propTypes = {
  name: PropTypes.string.isRequired,
  settings: PropTypes.arrayOf(PropTypes.string).isRequired,
  index: PropTypes.number.isRequired
}

export default BigSelectMenu;